export default function Metrics({ children, prefix }) {
  return <div className={`${prefix}flex ${prefix}flex-col ${prefix}py-1`}>{children}</div>;
}
